var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.arrowClass,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('arrowClick')}}},[_c('img',{attrs:{"src":require("@/assets/img/arrow-back.png")}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }